export default "__VITE_ASSET__BLo39ge8__"